import { createContext, useContext, useState, useCallback, useEffect } from "react";
import api from "../lib/api";

const BillingContext = createContext(null);

export function BillingProvider({ children, isAuthed }) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!isAuthed) {
      setStatus(null);
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.get("/billing/status");
      setStatus(data);
    } catch {
      setStatus(null);
    } finally {
      setLoading(false);
    }
  }, [isAuthed]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const startTrial = async () => {
    const { data } = await api.post("/billing/trial");
    setStatus(data);
    return data;
  };

  const checkout = async (plan) => {
    const origin = window.location.origin;
    const { data } = await api.post("/billing/checkout", { plan, origin });
    window.location.href = data.url;
  };

  const syncSession = async (sessionId) => {
    const { data } = await api.post(`/billing/sync?session_id=${encodeURIComponent(sessionId)}`);
    setStatus(data);
    return data;
  };

  return (
    <BillingContext.Provider value={{ status, loading, refresh, startTrial, checkout, syncSession }}>
      {children}
    </BillingContext.Provider>
  );
}

export const useBilling = () => useContext(BillingContext);
